import styled from 'styled-components'

export default styled.div`
	font-size: 13px;
	font-weight: 600;
`
